module.exports = __webpack_public_path__ + "img/exe.281f55bc.png";